module.exports = __webpack_public_path__ + "media/images/arrow-triple-right-13c38685b4240d88aafb103320dcda61.png";